import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13a33564"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tab-pane fade show active m-2 tab-content",
  id: "CurrentCensusTabContent",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_2 = {
  id: "censusFormContainer",
  class: "txtLeft"
}
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "FROM", -1))
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "TO", -1))
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PART OF DAY", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  selected: ""
}, "All Templates...", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  class: "col-2 search-wrapper",
  style: {"padding-top":"20px"}
}
const _hoisted_18 = { class: "col-7 text-right pt-4" }
const _hoisted_19 = { title: "Interface Enabled" }
const _hoisted_20 = { "aria-hidden": "true" }
const _hoisted_21 = { class: "activityLog-grid-container mt-2" }
const _hoisted_22 = {
  id: "census-content-loading",
  class: "text-center mt-3"
}
const _hoisted_23 = { class: "fa-2x" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_25 = { id: "statusGrid" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  title: "Interface Enabled"
}
const _hoisted_28 = { "aria-hidden": "true" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { "aria-hidden": "true" }
const _hoisted_33 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_34 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedFacilities,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
                _ctx.onFacilityChange
              ],
              options: _ctx.facilities,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              label: "Text",
              "track-by": "Text",
              placeholder: "All Facilities...",
              id: "selFacilities"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedDepartments,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
              options: _ctx.departments,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              placeholder: "All Departments...",
              label: "Text",
              "track-by": "Text",
              id: "selDepartments"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedStartDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStartDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: true,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedEndDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEndDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: true,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "facility",
              id: "partOfDayDropdown",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPartOfDay) = $event))
            }, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partOfDays, (partOfDay) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: partOfDay.partOfDayId,
                  key: partOfDay.partOfDayId
                }, _toDisplayString(partOfDay.partOfDayName), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedPartOfDay]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              id: "manageCensusSearch",
              class: "float-end me-1",
              onClick: _ctx.searchClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SEARCH ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, [
              _createElementVNode("i", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, {
                  class: "meditechEnabledIcon",
                  icon: ['fas', 'check'],
                  size: "lg"
                })
              ]),
              _createTextVNode(" " + _toDisplayString("Interface Enabled"))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _withDirectives(_createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_font_awesome_icon, {
              spin: true,
              icon: ['fas', 'circle-notch'],
              size: "lg"
            })
          ]),
          _hoisted_24
        ], 512), [
          [_vShow, _ctx.isShowLoader]
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_neu_card, {
            color: "plain-0",
            class: "p-0 m-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_neu_table, { class: "censusTbl" }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_table_row, {
                    size: "small",
                    columns: _ctx.columnHeaders,
                    header: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                        return (_openBlock(), _createBlock(_component_neu_table_heading, {
                          key: column,
                          icon: _ctx.columnIcons[column],
                          slot: column,
                          style: {"padding-top":"25px !important"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(column), 1)
                          ]),
                          _: 2
                        }, 1032, ["icon", "slot"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["columns"]),
                  _createVNode(_component_neu_table_body, {
                    align: "left",
                    class: "scrollBar"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.censusGridData != null && _ctx.censusGridData.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.censusGridDataList, (mngCensus) => {
                            return (_openBlock(), _createBlock(_component_neu_table_row, {
                              size: "small",
                              columns: _ctx.columnHeaders,
                              key: mngCensus,
                              slot: _ctx.column
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_label, {
                                  slot: "Facility",
                                  title: mngCensus.facilityName
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(mngCensus.facilityName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["title"]),
                                _createVNode(_component_neu_label, {
                                  slot: "Department",
                                  title: mngCensus.deptName
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(mngCensus.deptName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["title"]),
                                _createVNode(_component_neu_label, { slot: "Date" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.buildDateTemplate(mngCensus.date)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Start Time" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.buildTimeTemplate(mngCensus.startTime)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "End Time" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.buildTimeTemplate(mngCensus.endTime)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Forecast" }, {
                                  default: _withCtx(() => [
                                    (this.profileData.ForecastCensusEditEnabled)
                                      ? (_openBlock(), _createBlock(_component_neu_input, {
                                          key: 0,
                                          maxlength: "5",
                                          modelValue: mngCensus.forecast,
                                          "onUpdate:modelValue": ($event: any) => ((mngCensus.forecast) = $event),
                                          onChange: ($event: any) => (_ctx.onTextChange(mngCensus.forecastCensusId))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(mngCensus.forecast), 1))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Actual" }, {
                                  default: _withCtx(() => [
                                    (mngCensus.importedOnUtc != null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                          _createTextVNode(_toDisplayString((mngCensus.actual == null) ? '' :mngCensus.actual) + " ", 1),
                                          _createElementVNode("i", _hoisted_28, [
                                            _createVNode(_component_font_awesome_icon, {
                                              class: "meditechEnabledIcon",
                                              icon: ['fas', 'check'],
                                              size: "lg"
                                            })
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString((mngCensus.actual == null) ? '' :mngCensus.actual), 1))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Staff To" }, {
                                  default: _withCtx(() => [
                                    (this.profileData.CensusEditEnabled)
                                      ? (_openBlock(), _createBlock(_component_neu_input, {
                                          key: 0,
                                          maxlength: "5",
                                          onChange: ($event: any) => (_ctx.onTextChange(mngCensus.forecastCensusId)),
                                          value: (mngCensus.staffTo == null) ? '' :mngCensus.staffTo,
                                          onInput: ($event: any) => (mngCensus.staffTo = $event.target.value)
                                        }, null, 8, ["onChange", "value", "onInput"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString((mngCensus.staffTo == null) ? '' :mngCensus.staffTo), 1))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Notes" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_input, {
                                      maxlength: "50",
                                      modelValue: mngCensus.notes,
                                      "onUpdate:modelValue": ($event: any) => ((mngCensus.notes) = $event),
                                      onChange: ($event: any) => (_ctx.onTextChange(mngCensus.forecastCensusId))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_neu_label, { slot: "Actions" }, {
                                  default: _withCtx(() => [
                                    (mngCensus.isShowSave)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: "#",
                                          title: "Save",
                                          onClick: ($event: any) => (_ctx.onCensusSave(mngCensus.forecastCensusId))
                                        }, [
                                          _createElementVNode("i", _hoisted_32, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fas', 'save'],
                                              size: "2xl"
                                            })
                                          ])
                                        ], 8, _hoisted_31))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["columns", "slot"]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("p", _hoisted_33, "No data available on current page."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.censusGridData != null && _ctx.censusGridData.length > 0)
            ? (_openBlock(), _createBlock(_component_neu_container, {
                key: 0,
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_col, {
                        md: "6",
                        cols: "12",
                        class: "neu-text-center neu-text-md-left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_paginator, {
                            class: "justify-content-start",
                            onVNeuChange: _cache[5] || (_cache[5] = (ev) => this.pageNum = ev.detail.pageNumber),
                            total: _ctx.censusGridData != null && _ctx.censusGridData.length,
                            rowsPerPage: _ctx.rowsPerPage
                          }, null, 8, ["total", "rowsPerPage"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_neu_col, {
                        md: "6",
                        cols: "12",
                        class: "neu-text-center neu-text-md-right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_table_row_count, {
                            class: "mt-3",
                            section: "number",
                            total: _ctx.censusGridData != null && _ctx.censusGridData.length,
                            "page-number": _ctx.pageNum,
                            onVNeuChange: _ctx.rowCountChange
                          }, null, 8, ["total", "page-number", "onVNeuChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}